var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-aside", {
    staticClass: "header"
  }, [_c("img", {
    staticClass: "logo",
    staticStyle: {
      "max-width": "95px"
    },
    attrs: {
      src: require("../assets/images/logo-vertical.png"),
      alt: "logo"
    }
  }), _vm._v(" "), _c("nav", [_c("router-link", {
    attrs: {
      to: "/home",
      "active-class": "active"
    }
  }, [_c("i", {
    staticClass: "t-icon home"
  })]), _vm._v(" "), _c("span", {
    staticClass: "line"
  }), _vm._v(" "), _c("router-link", {
    attrs: {
      to: "/references",
      "active-class": "active"
    }
  }, [_c("i", {
    staticClass: "t-icon people"
  })]), _vm._v(" "), _c("span", {
    staticClass: "line"
  }), _vm._v(" "), _c("router-link", {
    attrs: {
      to: "/customer-representative",
      "active-class": "active"
    }
  }, [_c("i", {
    staticClass: "t-icon voice"
  })]), _vm._v(" "), _c("span", {
    staticClass: "line"
  }), _vm._v(" "), _c("router-link", {
    attrs: {
      to: "/my-account",
      "active-class": "active"
    }
  }, [_c("i", {
    staticClass: "t-icon person"
  })]), _vm._v(" "), _c("span", {
    staticClass: "line"
  }), _vm._v(" "), _c("a", {
    staticClass: "call area",
    attrs: {
      href: "tel:4442353"
    }
  }, [_c("div", {
    staticClass: "bg"
  }, [_c("i", {
    staticClass: "t-icon call"
  }), _vm._v(" "), _c("span", {
    staticClass: "call-text"
  }, [_vm._v("444 3 283")])])])], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };